// Affaire commandable : statut DEP, NCCL ou NDEP et imputable, ou statut ACHV ou RCPV quel que
// soit `imputable`. Même règle que BusinessRepository::orderable() côté API.
const ORDERABLE_IF_IMPUTABLE = ["business_dep", "business_nccl", "business_ndep"];
const ORDERABLE_ALWAYS = ["business_achv", "business_rcpv"];

export default function isOrderableBusiness(business) {
  const slug = business.status && business.status.status_slug;

  return (
    ORDERABLE_ALWAYS.includes(slug) ||
    (ORDERABLE_IF_IMPUTABLE.includes(slug) && business.imputable == 1)
  );
}



// WEBPACK FOOTER //
// ./src/components/Business/orderable.js